import { render, staticRenderFns } from "./RomaPercentage.vue?vue&type=template&id=31a0a54c"
import script from "./RomaPercentage.vue?vue&type=script&lang=ts"
export * from "./RomaPercentage.vue?vue&type=script&lang=ts"
import style0 from "./RomaPercentage.vue?vue&type=style&index=0&id=31a0a54c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports